import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=08312b19&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08312b19')) {
      api.createRecord('08312b19', component.options)
    } else {
      api.reload('08312b19', component.options)
    }
    module.hot.accept("./Widget.vue?vue&type=template&id=08312b19&", function () {
      api.rerender('08312b19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/gobierto_dashboards/webapp/components/Widget.vue"
export default component.exports